import React, { ChangeEvent, useState } from 'react';
import { GoalI } from '../../interfaces/GoalInterface';

export interface GoalFormProps {
    onSubmit: Function,
    initFormData: GoalI,
}

const GoalForm = (props: GoalFormProps) => {
    const { onSubmit, initFormData } = props;

    const [formObj, setFormObj] = useState<GoalI>(initFormData);

    return <form onSubmit={e => onSubmit(e, formObj)}>

        <input name='title' type='text' value={formObj['title']} onChange={onChangeForm}
            placeholder='Give your goal a name' required />

        <textarea name='des' value={formObj['des']} onChange={onChangeForm}
            placeholder='Describe your goal' required />

        <select name="category"
            value={formObj['details']['category']}
            onChange={onChangeForm}
            placeholder='Type of goal'
            required
        >
            {/* <option value=''>Type of goal</option> */}
            <option value="reading-book">Reading Book</option>
        </select>

        {
            formObj['details']['category'] === 'reading-book'
                ?
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!formObj['details']['chapters']
                        // || formObj['details']['chapters'] === 0
                        ? <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '40%' }}>
                            <label>Pages</label>
                            <input name='pages' type='number' value={formObj['details']['pages']}
                                onChange={onChangeForm} min={0} required /> </div> : null}

                    {!formObj['details']['chapters'] && !formObj['details']['pages']
                        ? <span style={{ margin: 'auto 0.5rem', fontWeight: 'bold' }}>OR</span> : null}

                    {!formObj['details']['pages']
                        // || formObj['details']['pages'] === 0
                        ? <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '40%' }}>
                            <label>Chapters</label>
                            <input name='chapters' type='number' value={formObj['details']['chapters']}
                                onChange={onChangeForm} min={0} required /></div> : null}
                </div>
                : null
        }

        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '40%' }}>
                <label>Starting</label>
                <input name='startTime' type='date'
                    value={formObj['startTime']} onChange={onChangeForm} required />
            </div>
            <span style={{ margin: 'auto 0.5rem' }} />
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '40%' }}>
                <label>Finishing</label>
                <input name='endTime' type='date'
                    value={formObj['endTime']} onChange={onChangeForm} required />
            </div>
        </div>

        <label>Urgent?</label>
        <select name="priority"
            placeholder='Urgent?'
            value={formObj['priority']}
            onChange={onChangeForm}
            required>
            <option value="-1">Nah</option>
            <option value="0">Ok</option>
            <option value="1">YES!</option>
        </select>

        <button type='submit' className='btn'>Set!</button>
    </form>;


    function onChangeForm(event: ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>): void {
        const { name, value } = event.target;

        var preFormObj = { ...formObj };

        if (name === 'pages'
            || name === 'chapters'
            || name === 'category') {
            preFormObj = {
                ...formObj,
                details: {
                    ...formObj['details'],
                    [name]: value
                }
            };
        } else {
            preFormObj = {
                ...formObj,
                [name]: value
            };
        }

        setFormObj(preFormObj);
    }

};

export default GoalForm;